import { createContext, useContext } from "react";
import { useLocalStorage, useSessionStorage } from "../hook/useStorage";

const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  // const [user, setUser] = useState(null);
  const [user, setUser, removeUser] = useSessionStorage("user", null);

  const login = (user) => {
    setUser(user);
  };

  const logout = () => {
    setUser(null);
    removeUser();
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  return useContext(AuthContext);
};

export { AuthProvider, useAuth };
